import { useState } from 'react';
import LiveTrackingComponent from '../components/LiveTrackingComponent';
import SelectRouteComponent from '../components/SelectRouteComponent';
import DestinationOriginToggleComponent from '../components/DestinationOriginToggleComponent';

const HomeScreenComponent = () => {
  const day = new Date().getDay();

  let lineSettings = {
    // PANEPISTIMIO
    '07': {
      busStopIdOrigin: '005',
      busStopIdDest:  0 < day && day < 6 ? '200' : '139', // POLITIKOUS : FOITITIKI ESTIA M
      lineColor: 'red',
      routeId: 0 < day && day < 6 ? '07' : '53',
      centerMapAt: [41.141193, 24.903092],
      splitRouteAt: 0 < day && day < 6 ? 119 : 32,
    },
    // KIMMERIA
    '02': {
      busStopIdOrigin: '005',
      busStopIdDest: '175', // TERMA MIKRAS ASIAS
      lineColor: 'purple',
      routeId: '02',
      centerMapAt: [41.144499, 24.90113],
      splitRouteAt: 229,
    },
    // KIMMERIA PIGADIA
    11: {
      busStopIdOrigin: '005',
      busStopIdDest: '151', // ERGATIKA PHGADIWN M
      lineColor: 'blue',
      routeId: '11',
      centerMapAt: [41.14478, 24.904934],
      splitRouteAt: 340,
    },
  };

  const [lineId, setLineId] = useState('07');
  const [alignment, setAlignment] = useState('to');

  return (
    <div className='container'>
      <div className='selectors'>
        <DestinationOriginToggleComponent alignment={alignment} setAlignment={setAlignment} />
        <SelectRouteComponent lineId={lineId} setLineId={setLineId} />
      </div>
      <LiveTrackingComponent lineId={lineId} alignment={alignment} lineSettings={lineSettings} />
    </div>
  );
};

export default HomeScreenComponent;
